var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKnowledgeTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 338,
    height: 248,
    viewBox: "0 0 338 248",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26004",
    "data-name": "Group 26004",
    transform: "translate(-890.5 -314.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26001",
    "data-name": "Group 26001",
    transform: "translate(0 35)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Prospecting_and_download_",
    "data-name": "Prospecting and  download\\u200B",
    transform: "translate(1093 304)",
    fill: "#191817",
    fontSize: 14,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Prospecting and "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 22
  }, "download\u200B")), /*#__PURE__*/React.createElement("g", {
    id: "Group_26000",
    "data-name": "Group 26000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25997",
    "data-name": "Group 25997",
    transform: "translate(924 284.159)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15264",
    "data-name": "Rectangle 15264",
    width: 172,
    height: 61,
    rx: 8,
    transform: "translate(-33 -4.159)",
    fill: "#faebe7",
    stroke: "#bd1822",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    id: "Knowledge_Team",
    "data-name": "Knowledge Team",
    transform: "translate(53 20.841)",
    fill: "#bd1822",
    fontSize: 14,
    fontFamily: "Poppins",
    fontWeight: 600,
    letterSpacing: "0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -46,
    y: 0
  }, "KNOWLEDGE"), /*#__PURE__*/React.createElement("tspan", {
    x: -20,
    y: 21
  }, "TEAM"))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3928",
    "data-name": "Ellipse 3928",
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    transform: "translate(1058 305)",
    fill: "#bd1822"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26002",
    "data-name": "Group 26002"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25998",
    "data-name": "Group 25998",
    transform: "translate(1089 412.159)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15264-2",
    "data-name": "Rectangle 15264",
    width: 172,
    height: 61,
    rx: 8,
    transform: "translate(-33 -4.159)",
    fill: "#f4e2f9",
    stroke: "#954cc9",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    id: "Pre_Sales_Team",
    "data-name": "Pre Sales Team",
    transform: "translate(53 20.841)",
    fill: "#954cc9",
    fontSize: 14,
    fontFamily: "Poppins",
    fontWeight: 600,
    letterSpacing: "0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -37,
    y: 0
  }, "PRE SALES"), /*#__PURE__*/React.createElement("tspan", {
    x: -20,
    y: 21
  }, "TEAM"))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3929",
    "data-name": "Ellipse 3929",
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    transform: "translate(1051 433)",
    fill: "#954cc9"
  }), /*#__PURE__*/React.createElement("text", {
    id: "RFQ_replies_",
    "data-name": "RFQ replies\\u200B",
    transform: "translate(915 445)",
    fill: "#191817",
    fontSize: 14,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "RFQ replies\u200B"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26003",
    "data-name": "Group 26003",
    transform: "translate(-3 -34)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25999",
    "data-name": "Group 25999",
    transform: "translate(927 539.159)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15264-3",
    "data-name": "Rectangle 15264",
    width: 172,
    height: 61,
    rx: 8,
    transform: "translate(-33 -4.159)",
    fill: "#faebe7",
    stroke: "#bd1822",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    id: "Client_Service_Team",
    "data-name": "Client Service Team",
    transform: "translate(53 20.841)",
    fill: "#bd1822",
    fontSize: 14,
    fontFamily: "Poppins",
    fontWeight: 600,
    letterSpacing: "0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -58,
    y: 0
  }, "CLIENT SERVICE"), /*#__PURE__*/React.createElement("tspan", {
    x: -20,
    y: 21
  }, "TEAM"))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3930",
    "data-name": "Ellipse 3930",
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    transform: "translate(1061 560)",
    fill: "#bd1822"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Project_coordination_",
    "data-name": "Project  coordination\\u200B",
    transform: "translate(1096 560)",
    fill: "#191817",
    fontSize: 14,
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Project "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 22
  }, "coordination\u200B"))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnowledgeTeam);
export default __webpack_public_path__ + "static/media/knowledgeTeam.be87a40342fde0aa2d0d0399bb3592c1.svg";
export { ForwardRef as ReactComponent };